<template>
  <BModal :value="value" title="Ta bort projekt" @input="$emit('input', false)">
    <div slot="body" class="content">
      <p>
        Du är på väg att ta bort projektet
        <i>"{{ project.title.value }}"</i>.
      </p>
      <p class="has-text-weight-bold">Är du säker?</p>
    </div>
    <div slot="footer">
      <button
        class="button is-danger"
        :disabled="isLoading"
        :class="{ 'is-loading': isLoading }"
        @click="Delete()"
      >
        Ja, ta bort
      </button>
      <button class="button" @click="$emit('input', false)">Avbryt</button>
    </div>
  </BModal>
</template>

<script>
import BModal from "@/components/singles/BModal/component.vue";

export default {
  components: { BModal },
  props: ["value", "project"],
  data() {
    return {
      show: false,
      isLoading: false
    };
  },
  methods: {
    async Delete() {
      this.isLoading = true;

      await this.$helpers.PostApi("delete/images", this.project.images);

      let result = await this.$helpers.PostApi("delete/card", {
        uid: this.project.uid
      });

      this.isLoading = false;
      this.$helpers.ShowStatus("Projektet är borttaget.", 5000, "success");
      this.$emit("input", false);
      this.$emit("deleted", true);
    }
  }
};
</script>
